import { DiscountGroupType } from "@redotech/redo-discounts-common/discount";
import {
  DiscountCategory,
  redoDiscountSchema,
} from "@redotech/redo-discounts-common/discount/discount-db-parser";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getDiscountsByTeam = {
  name: "getDiscountsByTeam" as const,
  input: z.object({
    groupType: createEnum(DiscountGroupType).optional(),
    category: createEnum(DiscountCategory).optional(),
  }),
  output: z.array(redoDiscountSchema),
};
